// Formata a duração de "1 tempo" (ver ComboPreco.duracaoTempoMinutos, vindo
// da tabela de preço do app local via /configuracao/combos) pra texto
// legível — "1h", "1h30" ou "45min". Nunca escrito à mão na tela: sempre
// calculado a partir do que o app local configurou.
export function formatDuracaoMinutos(minutos) {
    const horas = Math.floor(minutos / 60)
    const resto = minutos % 60

    if (horas === 0) return `${resto}min`
    if (resto === 0) return `${horas}h`
    return `${horas}h${resto.toString().padStart(2, '0')}`
}
